module.exports = __webpack_public_path__ + "static/car4-6d73aef8c90b62eae3973f55d2191079.jpg";